import _ from 'lodash';
import FJTextBaseEditPreviewStore from '../../../store/FJTextBaseEditing/FJTextBaseEditPreviewStore.js';
import {
    setSliceHasRedo,
    setSliceHasUndo,
    setSliceIsBlank,
    setSliceIsPlaying,
    setSliceSelectTimeList,
    setSliceSourceType,
    setSliceSplitTimeList,
    setSliceThumbnailBlobUrl,
    setSliceTrimInfo,
    TEXT_BASE_EDITING_SOURCE_TYPE,
} from '../../slices/FJSliceRightTextBaseEditing.js';
import FJActionTimeLine from '../FJActionTimeLine.js';
import FJTextEditStore from '../../../store/FJTextBaseEditing/FJTextEditStore.js';
import FJEvent from '../../../store/FJEvent.js';
import { setEditFloatingPanelVisible } from '../../slices/FJSliceTextEditFloatingPanel.js';
import FJTextContent from '../../../core/textBasedEditing/FJTextContent.js';
import FJActionTextBasedEditing from './FJActionTextBasedEditing.js';
import FJTextBaseEditingUtil from '../../../util/FJTextBaseEditingUtil.js';
import FJMessageStore from '../../../store/FJMessageStore.js';
import FJLocalStore from '../../../store/FJLocalStore.js';
import FJTextBaseEditExportStore from '../../../store/FJTextBaseEditing/FJTextBaseEditExportStore.js';
import { setProgressAction, setProgressModalData, setSliceLoadingModalData } from '../../slices/FJSliceModals.js';
import FJActionTextBasedEditingExtension from './FJActionTextBasedEditingExtension.js';
import FJUtil from '../../../util/FJUtil.js';

let debounceUpdateThumbnailUrl = null;

let _initThumbnailUrl = false;
const FJActionRightTextBaseEditing = {
    /**
     * @desc 初始化右文本编辑
     * @param {string} url
     * @param {string} type
     */
    initRightTextBaseEditingAction: function (url, type) {
        return async (dispatch, getState) => {
            dispatch(this.clearRightTextBaseEditingAction());
            const sourceInfo = await FJTextBaseEditPreviewStore.init(url, type);
            if (!sourceInfo) return;

            dispatch(setSliceIsBlank(false));
            dispatch(setSliceSourceType(type));
            dispatch(this.updateHasUndoRedoAction());
            dispatch(
                setSliceTrimInfo({
                    start: 0,
                    end: sourceInfo.duration,
                }),
            );

            FJTextBaseEditPreviewStore.setTimeData(0, sourceInfo.duration);
            dispatch(FJActionTimeLine.setTotalTimeAction(sourceInfo.duration));
            dispatch(this.setSplitTimeListAction([{ startTime: 0, endTime: sourceInfo.duration }]));

            const containerWidth = getState().timeLine.containerWidth;
            dispatch(FJActionTimeLine.updateUnitConversionAction(containerWidth, true));
            _initThumbnailUrl = false;
            dispatch(this.seekAction(0));
            dispatch(this.updateThumbnailAction());
        };
    },

    /**
     * @desc 清除右文本编辑
     */
    clearRightTextBaseEditingAction: function () {
        return async () => {
            FJTextBaseEditPreviewStore.clear();
        };
    },

    /**
     * @desc 设置选中的时间段列表
     * @param {Array} selectTimeList
     */
    setSelectTimeListAction: function (selectTimeList) {
        return async dispatch => {
            dispatch(setSliceSelectTimeList(selectTimeList));
        };
    },

    /**
     * @desc 设置分割时间列表
     * @param {Array} splitTimeList
     */
    setSplitTimeListAction: function (splitTimeList) {
        return async (dispatch, getState) => {
            const currentTime = getState().timeLine.currentTime;

            FJTextBaseEditPreviewStore.setSplitTimeList(splitTimeList);
            dispatch(setSliceSplitTimeList(splitTimeList));
            const newDuration = splitTimeList.reduce((total, item) => {
                return total + (item.endTime - item.startTime);
            }, 0);

            dispatch(FJActionTimeLine.setTotalTimeAction(newDuration));

            dispatch(this.seekAction(currentTime > newDuration ? 0 : currentTime));
        };
    },

    /**
     * @desc 设置视频画布
     * @param {HTMLCanvasElement} canvas
     * @returns
     */
    setVideoCanvasAction: function (canvas) {
        return async dispatch => {
            FJTextBaseEditPreviewStore.setVideoCanvas(canvas);
            dispatch(this.seekAction(0));
            dispatch(this.updateThumbnailAction());
        };
    },

    resizeAction: function () {
        return async () => {
            FJTextBaseEditPreviewStore.resizeView();
        };
    },

    /**
     * @desc 跳转到指定帧
     * @param {Number} time
     */
    seekAction: function (time) {
        return async dispatch => {
            dispatch(this.pauseAction());
            dispatch(FJActionTimeLine.setCurrentTimeAction(time));
            FJTextBaseEditPreviewStore.seek(time).catch(e => {
                console.log(e);
            });
        };
    },

    switchPlayStateAction: function () {
        return (dispatch, getState) => {
            const isPlaying = getState().rightTextBaseEditing.isPlaying;
            if (isPlaying) dispatch(FJActionRightTextBaseEditing.pauseAction());
            else dispatch(FJActionRightTextBaseEditing.playAction());
        };
    },

    /**
     * @desc 暂停
     */
    pauseAction: function () {
        return async (dispatch, getState) => {
            const isPlaying = getState().rightTextBaseEditing.isPlaying;
            if (!isPlaying) {
                return;
            }

            FJTextBaseEditPreviewStore.pause().catch(e => {
                console.log(e);
            });
            dispatch(setSliceIsPlaying(false));
            FJTextContent.renderStyle();
            FJEvent.dispatch('CLOSE_LANGUAGE_SELECT_PANEL');
        };
    },

    /**
     * @desc 播放
     */
    playAction: function () {
        return async (dispatch, getState) => {
            const loadingModeDisplay = getState().modals.loadingModalData.display;
            if (loadingModeDisplay) return;
            if (FJTextBaseEditExportStore.isExport()) return;

            const sliceIsPlaying = getState().rightTextBaseEditing.isPlaying;
            const { splitTimeList, trimInfo = {} } = getState().rightTextBaseEditing;

            if (sliceIsPlaying) {
                return;
            }

            // curTime单位s
            const callback = curTime => {
                dispatch(FJActionTimeLine.setCurrentTimeAction(curTime));
                // TODO 更新文字高亮显示
                const sourceTime = FJTextBaseEditingUtil.timeLineCurrentTimeToSourceCurrentTime(
                    curTime,
                    splitTimeList,
                    trimInfo.start,
                );
                const highlightItem = FJTextEditStore.highlightFromTime(sourceTime);
                if (highlightItem) {
                    dispatch(FJActionTextBasedEditingExtension.positionTextAction(highlightItem));
                }
            };

            const pauseCallback = () => {
                dispatch(this.seekAction(0));
                dispatch(this.pauseAction());
            };

            dispatch(setSliceIsPlaying(true));
            FJTextBaseEditPreviewStore.play(callback, pauseCallback);
            FJEvent.dispatch('CLOSE_LANGUAGE_SELECT_PANEL');
        };
    },

    /**
     * @desc 更新缩略图
     */
    updateThumbnailAction: function () {
        return async (dispatch, getState) => {
            const { trimInfo, sourceType } = getState().rightTextBaseEditing;
            const unitConversion = getState().timeLine.unitConversion;
            const thumbnailBlobUrl = getState().rightTextBaseEditing.thumbnailBlobUrl;

            const thumbnailSize = {
                width: unitConversion * (trimInfo.end - trimInfo.start),
                height: 60,
            };

            if (!thumbnailSize.width || isNaN(thumbnailSize.width)) {
                return;
            }

            if (!debounceUpdateThumbnailUrl) {
                debounceUpdateThumbnailUrl = _.debounce(
                    async (thumbnailSize, thumbnailBlobUrl, sourceType) => {
                        if (!_initThumbnailUrl && sourceType === TEXT_BASE_EDITING_SOURCE_TYPE.VIDEO) {
                            // 首次加载先加载视频首帧图
                            FJTextBaseEditPreviewStore.getThumbnailBlobUrlByFirstFrame(thumbnailSize, blobUrl => {
                                dispatch(setSliceThumbnailBlobUrl(blobUrl));
                                _initThumbnailUrl = true;
                            });
                        }

                        const newThumbnailBlobUrl =
                            await FJTextBaseEditPreviewStore.updateThumbnailBlobUrl(thumbnailSize);

                        if (thumbnailBlobUrl) {
                            URL.revokeObjectURL(thumbnailBlobUrl);
                        }
                        dispatch(setSliceThumbnailBlobUrl(newThumbnailBlobUrl));
                    },
                    200,
                    { trailing: true },
                );
            }
            debounceUpdateThumbnailUrl(thumbnailSize, thumbnailBlobUrl, sourceType);
        };
    },

    /**
     * @desc 下载视频
     */
    downloadVideoAction: function () {
        return async dispatch => {
            FJUtil.eaLog('text based editing video download click');
            dispatch(this.exportMergedAction());
        };
    },

    /**
     * @desc 导出
     */
    exportAction: function () {
        return async (dispatch, getState) => {
            const selectedType = getState().rightTextBaseEditing.selectedType;

            FJUtil.eaLog('text based editing add click', {
                type: selectedType === 'merged' ? 'merged' : 'splitted clips',
            });

            if (selectedType === 'merged') {
                dispatch(this.exportMergedAction(true));
            } else if (selectedType === 'splitted') {
                dispatch(this.exportSplitAction());
            }
        };
    },

    /**
     * @desc 合并导出
     */
    exportMergedAction: function (goToEditPage = false) {
        return async dispatch => {
            const __openProgressModal = () => {
                dispatch(setProgressAction(0));
                dispatch(
                    setProgressModalData({
                        display: true,
                        cancelCallback: () => {
                            FJTextBaseEditExportStore.cancelExport();
                        },
                    }),
                );
            };

            const __closeProgressModal = () => {
                dispatch(setProgressAction(0));
                dispatch(setProgressModalData({ display: false }));
            };

            __openProgressModal();
            FJTextBaseEditExportStore.startExport();
            FJTextBaseEditExportStore.exportMerged({
                onProgress: progress => {
                    dispatch(setProgressAction(progress));
                },
                onComplete: () => {
                    __closeProgressModal();
                    FJTextBaseEditExportStore.stopExport();
                    if (!goToEditPage) FJMessageStore.addMessage(FJLocalStore._('download-successfully'));
                },
                onError: error => {
                    __closeProgressModal();
                    FJTextBaseEditExportStore.stopExport();
                    if (error && error.message === 'Export cancelled') {
                        console.log('导出取消');
                    } else {
                        console.log('导出失败', error);
                        if (!goToEditPage)
                            FJMessageStore.addMessage(FJLocalStore._('failed-to-download-please-try-again'), 'error');
                        else
                            FJMessageStore.addMessage(FJLocalStore._('failed-to-processing-please-try-again'), 'error');
                    }
                },
                goToEditPage: goToEditPage,
            });
        };
    },

    /**
     * @desc 分割导出
     */
    exportSplitAction: function () {
        return async (dispatch, getState) => {
            const { splitTimeList } = getState().rightTextBaseEditing;
            dispatch(setSliceLoadingModalData({ display: true, message: `${FJLocalStore._('processing')}` }));
            FJTextBaseEditExportStore.startExport();
            const __close = () => {
                dispatch(setSliceLoadingModalData({ display: false }));
                FJTextBaseEditExportStore.stopExport();
            };

            FJTextBaseEditExportStore.exportSplit({
                splitTimeList: splitTimeList,
                onComplete: __close,
                onError: () => {
                    __close();
                    FJMessageStore.addMessage(FJLocalStore._('failed-to-processing-please-try-again'), 'error');
                },
            });
        };
    },

    updateSelectedTimesAction: function () {
        return dispatch => {
            dispatch(this.pauseAction());
            const selectTimeList = FJTextEditStore.getTimeDataForSelectedText();
            if (selectTimeList) {
                dispatch(setSliceSelectTimeList(selectTimeList));
            } else {
                dispatch(setSliceSelectTimeList([]));
            }
        };
    },
    updateSplitTimeListAction: function () {
        return dispatch => {
            const splitTimes = FJTextEditStore.getTimeDataForAllText();
            if (splitTimes) {
                dispatch(this.setSplitTimeListAction(splitTimes));
            } else {
                dispatch(this.setSplitTimeListAction([]));
            }
            dispatch(FJActionRightTextBaseEditing.updateSelectedTimesAction());
        };
    },

    /**
     * @desc 重置时间线数据
     */
    restoreTimeLineDataAction: function () {
        return (dispatch, getState) => {
            const sourceTrimInfo = getState().rightTextBaseEditing.trimInfo;
            dispatch(this.setSplitTimeListAction([{ startTime: 0, endTime: sourceTrimInfo.end }]));
            dispatch(this.setSelectTimeListAction([]));
        };
    },

    /**
     * @desc 更新撤销重做按钮状态
     */
    updateHasUndoRedoAction: function () {
        return dispatch => {
            dispatch(setSliceHasUndo(FJTextEditStore.hasUndo()));
            dispatch(setSliceHasRedo(FJTextEditStore.hasRedo()));
        };
    },

    /**
     * @desc 撤销
     */
    undoAction: function () {
        return (dispatch, getState) => {
            const loadingModeDisplay = getState().modals.loadingModalData.display;
            if (loadingModeDisplay) return;
            if (FJTextBaseEditExportStore.isExport()) return;
            FJTextEditStore.undo();
            dispatch(FJActionTextBasedEditing.renderAction());
            dispatch(this.updateSelectedTimesAction());
            dispatch(this.updateSplitTimeListAction());
            dispatch(setEditFloatingPanelVisible(false));
            dispatch(this.updateHasUndoRedoAction());
        };
    },

    /**
     * @desc 重做
     */
    redoAction: function () {
        return (dispatch, getState) => {
            const loadingModeDisplay = getState().modals.loadingModalData.display;
            if (loadingModeDisplay) return;
            if (FJTextBaseEditExportStore.isExport()) return;
            FJTextEditStore.redo(true);
            dispatch(FJActionTextBasedEditing.renderAction());
            dispatch(this.updateSelectedTimesAction());
            dispatch(this.updateSplitTimeListAction());
            dispatch(setEditFloatingPanelVisible(false));
            dispatch(this.updateHasUndoRedoAction());
        };
    },
};

export default FJActionRightTextBaseEditing;
